import React from 'react';
import Styles from './index.less';
import {
    fetchDocDataById,
    fetchTemplateById,
} from '@src/slide/application/service/ai-ssistant/ai-generator/fetch-template';
import { convert } from '@tencent/slide-markdown-converter';
import cloneDeep from 'lodash/cloneDeep';
import {
    IPresentationData,
} from '@tencent/slide-sdk-model';
import { transaction } from '@src/slide/domain/slide-app';
import Snackbar from '@tencent/dui/lib/components/Snackbar';
import i18n from '@i18next/i18n';
import { IChangeTemplateService } from '@src/slide/application/service/change-template-service/index.interface';
import { IDynamicService } from '@src/slide/infrastructure/module/independent/dynamic-loader/dynamic-service';
import classnames from 'classnames';
import { tdw } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/tdw-report';
import {
    TDWActionType,
    TDWModuleType,
    TDWOperationType,
} from '@src/slide/infrastructure/module/dependent/report/offline-data-report/constant';
import { openPay } from '@src/js/common/ark-extensions/dc-components/pay';
import { getAidForReport } from '@tencent/txdocs-aid';
import { isVip } from '@src/js/common/ark-extensions/dc-components/vip-linktext';

export interface ITemplateCardProps {
    id: string;
    icon?: string;
    name: string;
    needVip?: boolean;
    changeTemplateService?: IDynamicService<IChangeTemplateService>;
    disabled: boolean;
    aid?: string;
    // 是否使用完整功能的预览
    useFullPreview: boolean;
    onDisabledChange(disabled: boolean);
    getCoverSrc(item): Promise<string>;
}

interface ITemplateCardState {
    icon?: string;
}

/**
 * 模版切换卡片
 */
export default class TemplateCard extends React.PureComponent<ITemplateCardProps, ITemplateCardState> {
    private isConvert = false;
    private isFetch = false;
    private slideFileData;
    private presentationData: IPresentationData;
    private newMasterId: string;
    private isSnackbarClose = true;
    private loadingBar;
    private changeTemplateServiceInstance?: IChangeTemplateService;

    public constructor(props: ITemplateCardProps) {
        super(props);
        this.props.changeTemplateService?.promise().then((module) => {
            this.changeTemplateServiceInstance = module;
        });
        this.state = {
            icon: this.props.icon,
        };
        this.updateIcon();
    }

    public render() {
        return <div
            onClick={this.handleClick} className={classnames({
                [Styles['template-card']]: true,
            })} style={{
                backgroundImage: `url(${this.state.icon})`,
            }}>
            {this.props.needVip ? <div className={Styles['template-card-vip-icon']}></div> : null }
        </div>;
    }

    public handleClick = async () => {
        if (!this.isSnackbarClose) return;
        if (this.props.disabled) return;
        if (this.props.needVip && !isVip()) {
            openPay(this.props.aid!);
            return;
        }

        this.props.onDisabledChange(true);
        this.props.changeTemplateService?.promise().then((module) => {
            if (module.selectedName === this.props.name) return;
            this.handleSnackbar();
            transaction(async () => {
                try {
                    if (this.props.useFullPreview) {
                        await module.updateTemplateToSlide(this.props.id);
                    } else {
                        await this.initTemplateData();
                        await this.getFuzzyMatchingLayout();
                    }
                    this.handleSnackbar();
                    this.props.onDisabledChange(false);
                } catch (e) {
                    window.log.error('change-template-error', e);
                    this.handleSnackbar();
                    this.props.onDisabledChange(false);
                }
            });
        });
        tdw({
            opername: TDWOperationType.DOC_PPT,
            module: TDWModuleType.BEAUTIFY_TAB,
            action: TDWActionType.BEAUTIFY_SWITCH_TEMPLATE,
            ver5: this.props.name,
        });
    };

    /**
     * 首次切换时拉取模版数据
     */
    public initTemplateData = async () => {
        if (!this.isFetch || !this.slideFileData) {
            this.slideFileData = await fetchTemplateById(this.props.id);
            this.isFetch = true;
        }

        if (!this.isConvert) {
            this.presentationData = convert(cloneDeep(this.slideFileData));

            this.presentationData.masterList[0].cSld.name = this.props.name;
            this.isConvert = true;
        }
    };

    public getFuzzyMatchingLayout = async () => {
        await this.props.changeTemplateService?.promise().then(async (module) => {
            await module.changeTemplate(this.presentationData);
        });
    };

    private updateIcon = async () => {
        if (!this.props.icon && this.props.getCoverSrc) {
            this.props.getCoverSrc(this.props.id).then((icon) => {
                this.setState({
                    icon,
                });
            });
        }
    };

    private handleSnackbar = () => {
        if (!this.isSnackbarClose) {
            this.loadingBar.close();
            this.isSnackbarClose = true;
        } else {
            this.loadingBar = Snackbar.show({
                autoClose: false, // 若为true（默认），则不会返回引用
                type: 'loading',
                message: `${i18n.t('正在切换中')}...`,
            });
            this.isSnackbarClose = false;
        }
    };
}
